import {
  addDays,
  addHours,
  addMonths,
  addWeeks,
  addYears,
  isAfter,
  isBefore,
  subDays,
  subHours,
  subMonths,
  subWeeks,
  subYears,
} from 'date-fns';
import jsone from 'json-e';
import type { jsoneData } from '../../api/interfaces';

/** Helpers a rule author can call from a `showIfRule` or an `autocompleteRule`. */
const defaultContext = {
  addHours,
  addDays,
  addWeeks,
  addMonths,
  subHours,
  subDays,
  subWeeks,
  subMonths,
  addYears,
  subYears,
  dateNow: () => new Date().toString(),
  dateIsAfter: isAfter,
  dateIsBefore: isBefore,
};

/**
 * Runs one compiled rule through json-e.
 *
 * Returns `undefined` when the expression throws — a rule referencing a widget
 * that was since deleted, most often. Callers keep the rule's previous value in
 * that case, so one broken rule cannot blank out a whole subsection.
 *
 * The `?? true` is deliberate but questionable: an expression that evaluates to
 * null is treated as visible. Left as-is because published tender forms rely on
 * it; worth revisiting behind a form-schema version.
 */
export function evaluateRuleExpression(data: jsoneData): unknown {
  try {
    const result = jsone(data.template, {
      ...defaultContext,
      ...data.context,
    });
    return result ?? true;
  } catch (e) {
    console.log('Error while computing: ', e);
    return undefined;
  }
}
